import request from '@/utils/request'
const env = require('../../env/index.js')
const { baseURL, baseURL2, baseURL3, APPID, VUE_APP_AGENT_BASE_URL } = env
import store from '@/store'
import { signature, randomString } from '@/utils/index.js'
const SLBROWSER_PC_AI_ASSIST_AUTHORIZATION = 'slbrowser_pc_ai_assist_authorization'

/**
 * AIGC授权-申请
 * @param { Object} data 
 * @returns { Promise}
 */
const authorizeApply = (data, abortController) => {
  return request({
    method: 'post',
    url: `${baseURL3}cloud-browser-aigc-auth/rest/v2/token/ai-stick/apply`,
    headers: {
      realm: data.realm,
      token: data.token
    },
    signal: abortController?.signal
  })
}

const getAuthorization =  async (data = {}, abortController) => {
  console.log('游客模式获取权限', !store.state.loginInfo?.loginid)
  let token = ''
  if (!store.state.loginInfo?.loginid) {
    let nativeInfo = window.pcmjssdk ? await window.pcmjssdk.asyncBrowerQuery(
      'NEWPLUGIN_WRAPPLUGIN_GET_BASIC_SYSTEMINFO') : await window.SLBSDK.nativeCall("SLGetNativeInfo")
    console.log('nativeInfo', nativeInfo)
    if (nativeInfo) {
      nativeInfo = typeof nativeInfo === "object" ? nativeInfo : JSON.parse(nativeInfo)
      token = window.pcmjssdk ? nativeInfo.sn : nativeInfo.PCSN || nativeInfo.PCSuperSN
    }
    const params = {
      appId: APPID,
      nonce: randomString(10),
      sign_type: "RSA2",
      timestamp: Date.now(),
      touristId: token,
      touristType: 'sn'
    }
    const str = Object.keys(params)
      .sort()
      .filter((k) => params[k])
      .map((k) => `${k}=${params[k]}`)
      .join("&");

    params.sign = signature(str);
    return anthorizeApplyBySn(params, abortController)
    .then((res) => {
      if (res.code === 10000 && res.data && res.data.accessToken) {
        const slbrowser_pc_ai_assist_authorization = `${
          res.data.tokenType ? res.data.tokenType : "bearer"
        } ${res.data.accessToken}`;
        const slbrowser_pc_ai_assist_authorization_cookie = `${SLBROWSER_PC_AI_ASSIST_AUTHORIZATION}=${slbrowser_pc_ai_assist_authorization}${
          res.data.expires
            ? ";expires=" + new Date(res.data.expires).toUTCString()
            : ""
        }`;
        document.cookie = slbrowser_pc_ai_assist_authorization_cookie;
        return slbrowser_pc_ai_assist_authorization;
      }
    })
    .catch((err) => {
      console.log("授权申请失败", err);
    });
  } else {
    let loginInfo = {}
    try {
      loginInfo = window.pcmjssdk
        ? await window.pcmjssdk.commonMethod.getLoginInfo()
        : await window.SLBSDK.nativeCall("SLGetLoginStatus");
    } catch (error) {
      console.log(error)
    }
    // 从端获取浏览器信息(UUID)
    // const SLBInfo = await window.SLBSDK.nativeCall('SLGetNativeInfo')
    // const loginInfo = ;
    // const { realm } = SLBInfo;
    loginInfo = typeof loginInfo === "object" ? loginInfo : JSON.parse(loginInfo);
    store.commit("setLoginInfo", loginInfo);
    const { token, realm } = loginInfo;
    data.token = token;
    data.realm = realm;
    return authorizeApply(data, abortController)
    .then((res) => {
      if (res.code === 10000 && res.data && res.data.accessToken) {
        const slbrowser_pc_ai_assist_authorization = `${
          res.data.tokenType ? res.data.tokenType : "bearer"
        } ${res.data.accessToken}`;
        const slbrowser_pc_ai_assist_authorization_cookie = `${SLBROWSER_PC_AI_ASSIST_AUTHORIZATION}=${slbrowser_pc_ai_assist_authorization}${
          res.data.expires
            ? ";expires=" + new Date(res.data.expires).toUTCString()
            : ""
        }`;
        document.cookie = slbrowser_pc_ai_assist_authorization_cookie;
        return slbrowser_pc_ai_assist_authorization;
      }
    })
    .catch((err) => {
      console.log("授权申请失败", err);
    });
  } 
}

const anthorizeApplyBySn = (data, abortController) => {
  const url = `${baseURL3}cloud-browser-aigc/rest/v3/token/${window.pcmjssdk ? 'ai-stick' : 'pc'}/tourist/apply`
  return request({
    method: 'post',
    url,
    headers: {
      "Content-Type": 'application/json',
    },
    data,
    signal: abortController?.signal
  })
}

/**
 * 摘要
 * @param {Object} data 
 * @returns { Promise}
 */
const refine = (authorization, data, abortController) => {
  return request({
    method: 'post',
    url: `chat/api/v1/refine`,
    headers: { 'Content-Type': 'multipart/form-data; boundary=this-is-a-boundary', 'Authorization': authorization },
    data,
    signal: abortController.signal,
    transformRequest: [function (data) {
      const formdata = new FormData()
      for (const name in data) {
        formdata.append(name, data[name])
      }
      return formdata
    }]
  })
}

/**
 * 摘要2
 * @param {Object} data 
 * @returns { Promise}
 */
const mapReduce = (authorization, data, abortController) => {
  return request({
    method: 'post',
    url: `chat/api/v1/mapReduce`,
    headers: { 'Content-Type': 'multipart/form-data; boundary=this-is-a-boundary', 'Authorization': authorization },
    data,
    signal: abortController.signal,
    transformRequest: [function (data) {
      const formdata = new FormData()
      for (const name in data) {
        formdata.append(name, data[name])
      }
      return formdata
    }]
  })
}

/**
 * ai聊天-文档理解服务
 * @returns { String } url
 */
const aiFileChatCompletion = () => {
  return `${baseURL}cloud-ai-core/rest/v1/file/chat/completion`
}
/**
 * ai聊天-图片理解服务
 * @returns { String } url
 */
const aiMultimodalGeneration = () => {
  return `${baseURL}cloud-ai-core/rest/v1/multimodal/generation`
}
/**
 * ai聊天
 * @returns { String } url
 */
const aiTalk = () => {
  return `${baseURL}cloud-ai-core/rest/v1/chat/completion`
}

/**
 * ai翻译
 * @returns { String } url
  测试环境	https://cloud-aigc.mbgtest.lenovomm.com/txagent
  正式环境	https://asn.lenovomm.com/txagent/
 */
const aiTTranslate = () => {
  return `${VUE_APP_AGENT_BASE_URL}txagent/rest/v1/agent/chat`
}

export {
  authorizeApply,
  getAuthorization,
  anthorizeApplyBySn,
  refine,
  mapReduce,
  aiFileChatCompletion,
  aiMultimodalGeneration,
  aiTalk,
  aiTTranslate
}